import { useHistory, useLocation } from 'react-router-dom';

import { Button, Modal } from 'src/components';
import { useUserState } from 'src/contexts/UserContext';

export const PaymentIssueModal: React.FC = () => {
  const { hasPaymentIssue } = useUserState();
  const { pathname } = useLocation();
  const history = useHistory();

  const isOnProfilePanel = pathname.startsWith('/me');
  const open = hasPaymentIssue && !isOnProfilePanel;

  return (
    <Modal open={open}>
      <Modal.Title>Problem z płatnością</Modal.Title>
      <Modal.Content>
        Ostatnia próba pobrania płatności nie powiodła się. Sprawdź szczegóły
        i zaktualizuj dane karty w panelu użytkownika.
      </Modal.Content>
      <Modal.Actions>
        <Button
          label="Przejdź do panelu"
          onClick={() => history.push('/me/subscription')}
        />
      </Modal.Actions>
    </Modal>
  );
};
